import { Injectable } from '@angular/core';
import { ServiceBase } from '../../../shared/service-base/ServiceBase';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable()
export class PlanoFamiliaFiltrosService extends ServiceBase {
    private baseUrlService: string;
    url: string;

    constructor(http: HttpClient, router: Router) {
        super(http, router);
        this.baseUrlService = environment.URL_API
    }

    getFiltroDealers(): any {
        this.defineURLFiltroDealers();
        return this.get([]);
    }

    private defineURLFiltroDealers() {
        this.url = `${this.baseUrlService}/filtro/dealer`;
    }

    protected getURL(): string {
        return this.url;
    }

    private defineURLFiltroRegional() {
        this.url = `${this.baseUrlService}/filtro/regional`;
    }

    getFiltroRegional(): any {
        this.defineURLFiltroRegional();
        return this.get([]);
    }

}
